<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 2.7A6.295 6.295 0 0 0 2.7 9c0 3.483 2.817 6.3 6.3 6.3 3.483 0 6.3-2.817 6.3-6.3 0-3.483-2.817-6.3-6.3-6.3Zm1.944 1.269a5.413 5.413 0 0 1 3.087 3.078l-2.502 1.035a2.691 2.691 0 0 0-1.611-1.611l1.026-2.502Zm-3.888 0L8.1 6.462a2.694 2.694 0 0 0-1.638 1.629L3.969 7.056a5.429 5.429 0 0 1 3.087-3.087Zm-.009 10.062a5.429 5.429 0 0 1-3.087-3.087l2.502-1.035c.27.756.873 1.359 1.629 1.629l-1.044 2.493ZM7.2 9c0-.99.81-1.8 1.8-1.8s1.8.81 1.8 1.8-.81 1.8-1.8 1.8S7.2 9.99 7.2 9Zm3.753 5.031-1.035-2.502A2.652 2.652 0 0 0 11.529 9.9l2.493 1.044a5.347 5.347 0 0 1-3.069 3.087Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
